import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("sy_admin_token", data.token);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(apiError(err, "Login failed — check your details."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#070b12] min-h-screen text-[#f0f4f8] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8"><Logo /></div>
        <form onSubmit={submit} className="p-8 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/30 space-y-4" data-testid="admin-login-form">
          <h1 className="font-display uppercase text-2xl text-white text-center mb-2">Owner Login</h1>
          <input required type="email" placeholder="Email" data-testid="admin-email-input"
            className="w-full bg-[#070b12] border border-white/15 rounded-xl px-4 py-3 text-sm text-white focus:border-[#1e9bff] outline-none"
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <input required type="password" placeholder="Password" data-testid="admin-password-input"
            className="w-full bg-[#070b12] border border-white/15 rounded-xl px-4 py-3 text-sm text-white focus:border-[#1e9bff] outline-none"
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          <button type="submit" disabled={loading} data-testid="admin-login-submit-btn"
            className="w-full py-3.5 rounded-xl bg-[#1e9bff] text-black font-display uppercase tracking-wider hover:bg-[#60baff] transition-colors disabled:opacity-50">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <Link to="/" data-testid="admin-login-home-link" className="block text-center mt-6 text-xs font-mono-lbl text-[#93b4d4] hover:text-white transition-colors">
          ← Back to website
        </Link>
      </div>
    </div>
  );
}
